import { Action } from 'redux';

import { EditPublishedConnectionDraft } from '~src/bootstrap/redux/actions/AppActionTypes';

export interface EditPublishedConnectionDraftReduxAction extends Action {
  readonly draftLuid: string;
}

export function editPublishedConnectionDraft(draftLuid: string): EditPublishedConnectionDraftReduxAction {
  return {
    type: EditPublishedConnectionDraft,
    draftLuid
  };
}
